// asure.gremlins stores a function in the window object that can
// display a bootstrap toaster.

// window.alertNotify(message, icon, severity, allowDismiss, duration, notifyDuration, isModalOpen)

export function displayGremlinsToaster(message, severity = 'warning', duration = 3000) {
  window.alertNotify(
    message,
    'fa fa-check fa-3x pull-left',
    severity,
    'true',
    duration,
    null,
    'False',
  );
}



// WEBPACK FOOTER //
// ./src/helpers/displayGremlinsToaster.js